import { isNumber } from './is-number';

export type GetExceededDayValueOptions = {
  value?: number | null;
  target?: number | null;
};

// Strictly above: a day that exactly meets its target is complete, not exceeded.
export const getExceededDayValue = ({
  value,
  target,
}: GetExceededDayValueOptions): number | undefined =>
  isNumber(value) && isNumber(target) && target > 0 && value > target
    ? value
    : undefined;
